export default {
  isMain: process.env.VUE_APP_I18N_MODE === 'main',
  isSub: process.env.VUE_APP_I18N_MODE === 'sub',

  thisLanguage: process.env.VUE_APP_I18N_THIS_LANGUAGE,

  outLink: {
    lang: process.env.VUE_APP_I18N_OUT_LANG,
    text: `ไประบบ${process.env.VUE_APP_I18N_OUT_LANG}`,
    href: process.env.VUE_APP_I18N_OUT_LINK,
  },
};
